import {
  CloseButtonContainer,
  CookiesInfoContainer,
} from './CookiesPopup.styles';
import { BodyText, Cross, TitleText } from 'src/components/atomsLegacy';
import { useTheme } from 'styled-components';

interface Props {
  closePopup: () => void;
  popupState: string;
}

export const CookiesPopup = (props: Props) => {
  const theme = useTheme();
  return (
    <CookiesInfoContainer data-testid="cookies-popup">
      <CloseButtonContainer>
        <Cross onClick={props.closePopup} margin="10px 0 0 0" />
      </CloseButtonContainer>
      <TitleText
        label={
          props.popupState === 'error'
            ? 'Cookie consent required'
            : 'We use cookies'
        }
        weight="bold"
      />
      <BodyText weight="regular">
        {props.popupState === 'error'
          ? 'We use cookies to help us deliver the best experience on our platform. In order to use Vault, we require your active consent.'
          : 'Cookies help us deliver the best experience on our website. By using our website, you agree to the use of cookies.'}{' '}
        <a
          href="https://vaultplatform.com/cookies-policy-web/"
          target="_blank"
          rel="noreferrer"
          style={{
            color: theme.isVaultVariant
              ? theme.newPalette.neutral.N1000
              : theme.atlas.semantic.color.type.default,
          }}
        >
          Find out how we use cookies
        </a>
      </BodyText>
    </CookiesInfoContainer>
  );
};
